import { Skeleton } from "@mui/material";
import React from "react";
import { convertToKebabCase } from "src/helpers/helperFunctions";

const TabProduct = ({
  data,
  className,
  imageStyle,
  imageClassName,
  onClick,
  fontSmall = false,
  id,
  skeleton = false,
}: {
  data?: { name: string; image: string; [key: string]: any };
  className?: string;
  imageStyle?: React.CSSProperties;
  imageClassName?: string;
  onClick?: () => void;
  fontSmall?: boolean;
  id?: string;
  skeleton?: boolean;
}) => {
  return (
    <div
      className={`flex items-center shadow-all p-1.5 xl:p-2 2xl:p-[10px] cursor-pointer gap-1 xl:gap-1.5 2xl:gap-2 2xl:rounded-[10px] rounded-md border border-[#D5D5D5] shadow-[0px_0px_7px_#00000029] ${className}`}
      id={id || convertToKebabCase(data?.name || "")}
      onClick={() => onClick && onClick()}
    >
      <div
        className={`max-w-[70px] lg:max-w-[6vw] 2xl:max-w-[5vw] w-full aspect-[1/0.9] rounded-md flex items-center justify-center ${
          skeleton ? "" : "p-0.5 xl:p-1"
        } overflow-hidden bg-[#e5eceb] ${imageClassName}`}
      >
        {skeleton ? (
          <Skeleton variant="rectangular" width="100%" height="100%" />
        ) : (
          <img
            src={data?.image}
            alt={data?.name}
            className="max-w-[90%] max-h-[90%] object-contain"
            style={{
              ...imageStyle,
            }}
          />
        )}
      </div>
      {skeleton ? (
        <div className="flex flex-1 flex-col gap-2">
          <Skeleton variant="text" width="100%" height="100%" />
          <Skeleton variant="text" width="80%" height="100%" />
        </div>
      ) : (
        <div
          className={`${
            fontSmall
              ? "font-size-16px font-Poppins-Regular text-[#404040] break-all"
              : "font-size-17px font-Poppins-Medium text-[#2B2B2B]"
          }   line-clamp-2`}
        >
          {data?.name}
        </div>
      )}
    </div>
  );
};

export default TabProduct;
